<template>
    <div class="o-dashboard">
        <c-table
            ref="table"
            :columns="columnsProducts"
            :endpoint="'/api/repairdeliveries'"
            :placeholder="'Zoeken op ordernummer, serienummer, producten of eindklant'">
        </c-table>
    </div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';

export default {
    mixins: [ View, Form ],
    components: { CTable },
    data() {
        return {

        }
    },
    methods: {
        load(){
            this.$refs.table.load();
        },
        exportRepair() {
            const link = document.createElement('a');
            link.href = '/api/exportrepair?search=' + this.$refs.table.selection.search.all + '&sort=' + this.$refs.table.sort.column + '&order=' + this.$refs.table.sort.direction;
            document.body.appendChild(link);
            link.click();
        }
    },
    computed: {
        columnsProducts() {
            return [
                { name: 'order_number', label: 'Ordernummer', sortable: true, sort: true},
                { name: 'items.*.serial', label: 'Serienummer', sort: true},
                { name: 'items.*.product.name', label: 'Producten' },
                { name: 'endclientName', label: 'Eindklant' },
                { name: 'client.name', label: 'Eindgebruiker', sortable: true},
                { name: 'created_at',  component: 'CColumnDateWithHours', label: 'Datum melding', sortable: true },
                { name: 'finished_repair',  component: 'CColumnDateWithHours', label: 'Afgerond op'},
                { name: 'id', label: '', component: 'CColumnButton', props: { route: 'repairDetail' }},
            ];
        },
    },
    beforeUnmount(){
        this.$store.dispatch('listener/off', {
            event: 'exportRepair',
            listener: this.exportRepair
        });
    },
    created(){
        this.$store.dispatch('listener/on', {
            event: 'exportRepair',
            listener: this.exportRepair
        });
    },
}
</script>
